import { createTheme } from "@mui/material";

export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 300,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1438,
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 8,
        },
        // contained: {
        //   "&:hover": {
        //     backgroundColor: "#344741"
        //   }
        // },
        sizeSmall: {
          padding: "6px 16px",
        },
        sizeMedium: {
          padding: "8px 20px",
        },
        sizeLarge: {
          padding: "11px 24px",
        },
        textSizeSmall: {
          padding: "7px 12px",
        },
        textSizeMedium: {
          padding: "9px   16px",
        },
        textSizeLarge: {
          padding: "12px 16px",
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },

    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: "32px 24px",
          "&:last-child": {
            paddingBottom: "32px",
          },
        },
      },
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: {
          variant: "h6",
        },
        subheaderTypographyProps: {
          variant: "body2",
        },
      },
      styleOverrides: {
        root: {
          padding: "32px 24px",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "white",
        },
      },
    },

    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: "10px",
          backgroundColor: " #F5F7FB",
          height: "50px",
          fontSize: "1rem",
        },
      },
    },

    MuiCssBaseline: {
      styleOverrides: {
        "*": {
          boxSizing: "border-box",
          margin: 0,
          padding: 0,
        },
        html: {
          MozOsxFontSmoothing: "grayscale",
          WebkitFontSmoothing: "antialiased",
          display: "flex",
          flexDirection: "column",
          minHeight: "100%",
          width: "100%",
        },
        body: {
          display: "flex",
          flex: "1 1 auto",
          flexDirection: "column",
          minHeight: "100%",
          width: "100%",
        },
        "#__next": {
          display: "flex",
          flex: "1 1 auto",
          flexDirection: "column",
          height: "100%",
          width: "100%",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontWeight: "400",
          color: "#C2C3CB",
          borderRadius: "25px",

          "&.Mui-selected": {
            backgroundColor: "white",
            color: "black",
            fontWeight: "600",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "10px",
          background: "#F5F7FB",
          "&:hover fieldset": {
            borderColor: "#F5F7FB !important",
            borderWidth: 2,
          },
          "&.Mui-focused fieldset": {
            borderColor: "#F5F7FB !important",
          },
          "&.Mui-disabled fieldset": {
            borderColor: "#F5F7FB !important",
          },
        },
        notchedOutline: {
          borderColor: "#F5F7FB",
        },
      },
    },
    // MuiChip: {
    //   styleOverrides: {
    //     root: {
    //       borderRadius: "6px",
    //     },
    //   },
    // },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "#F3F4F6",
          ".MuiTableCell-root": {
            color: "#374151",
          },
          borderBottom: "none",
          "& .MuiTableCell-root": {
            borderBottom: "none",
            fontSize: "12px",
            fontWeight: 600,
            lineHeight: 1,
            letterSpacing: 0.5,
            textTransform: "uppercase",
          },
          "& .MuiTableCell-paddingCheckbox": {
            paddingTop: 4,
            paddingBottom: 4,
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        // Even though there is a hover rule we have to override it here. Don't ask.
        root: {
          "&.MuiTableRow-hover:hover": {
            backgroundColor: "#E9E9E9",
          },
        },
      },
    },
  },
  palette: {
    neutral: {
      main: "#D9822F",
      contrastText: "#fff",
    },
    acceptable: {
      main: "#458DE1",
      contrastText: "#fff",
    },
    moderate: {
      main: "#C9B300",
      contrastText: "#fff",
    },
    high: {
      main: "#FFB267",
      contrastText: "#fff",
    },
    very_high: {
      main: "#FF0000",
      contrastText: "#fff",
    },
    critical: {
      main: "#630101",
      contrastText: "#fff",
    },
    disabled: {
      main: "#E8EAEC",
      contrastText: "#6D6D8C",
      light: "#eceeef",
      dark: "#b9bbbc",
    },
    background: {
      default: "#F9FAFC",
      paper: "#FFFFFF",
    },
    divider: "#E6E8F0",
    primary: {
      main: "#191C1B",
      light: "#a9f6e0",
      dark: "#030E0B",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#0FB694",
      light: "#0FB694",
      dark: "#00A07F",
      contrastText: "#FFFFFF",
    },
    success: {
      main: "#14B8A6",
      light: "#43C6B7",
      dark: "#0E8074",
      contrastText: "#FFFFFF",
    },
    info: {
      main: "#2196F3",
      light: "#64B6F7",
      dark: "#0B79D0",
      contrastText: "#FFFFFF",
    },
    warning: {
      main: "#FFB020",
      light: "#FFBF4C",
      dark: "#B27B16",
      contrastText: "#FFFFFF",
    },
    error: {
      main: "#D14343",
      light: "#DA6868",
      dark: "#922E2E",
      contrastText: "#FFFFFF",
    },
    text: {
      primary: "#121828",
      secondary: "#65748B",
      disabled: "rgba(55, 65, 81, 0.48)",
    },
    pending: {
      main: "#bdbdbd",
      light: "#eeeeee",
      dark: "#616161",
      contrastText: "#FFFFFF",
    },
    button: {
      main: "#78c3ae",
      contrastText: "#fff",
      dark: "#669386",
    },
    deleteButton: {
      main: "#454242",
      contrastText: "#ffffff",
      dark: "#b6b8ba",
    },
    cardButton: {
      main: "#E3E5E5",
      contrastText: "#4A4A6A",
      dark: "#b6b8ba",
    },
  },
  shape: {
    borderRadius: 8,
  },

  typography: {
    title: {
      fontSize: "32px",
      fontWeight: "400",
      fontFamily: "Bebas Neue",
      
    },
    title1: {
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: "36px",
      lineHeight: "54px",
    },
    title2: {
      fontWeight: 600,
      fontSize: "20px",
    },
    title3: {
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: "14px",
      lineHeight: "21px",
    },
    title4: {
      fontFamily: "Barlow Condensed",
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: "36px",
      lineHeight: "43px",
    },
    title5: {
      fontFamily: "Barlow Condensed",
      fontSize: "22px",
      fonWeight: 600,
      lineHeight: "24px",
    },
    title6: {
      fontFamily: "Poppins",
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: "14px",
      lineHeight: "21px",
      color: "#C6D2CE",
    },

    title7: {
      fontFamily: "Bebas Neue",
      fontSize: "38px",
      fontWeight: 400,
      lineHeight: "43px",
      letterSpacing: "0em",
      textAlign: "left",
    },

    title8: {
      fontFamily: "Poppins",
      fontSize: "24px",
      fontWeight: 600,
      lineHeight: "36px",
      letterSpacing: "0em",
    },

    title9: {
      fontFamily: "Poppins",
      fontWeight: 600,
      fontSize: "15px",
      lineHeight: "21px",
      color: "#000000",
    },

    subtitle1: {
      fontSize: 24,
      fontWeight: "600",
    },
    subtitle2: {
      fontSize: 16,
      fontWeight: "600",
    },
    subtitle3: {
      fontSize: 20,
      fontWeight: "400",
      lineHeight: "24px",
      fontFamily: "Bebas Neue",
      fontStyle: "normal",
    },
    subtitle4: {
      fontSize: 14,
      fontWeight: "400",
      fontStyle: "normal",
      color: "rgba(0, 0, 0, 0.5)",
    },
    subtitle5: {
      fontSize: "14px",
      fontWeight: "300",
      lineHeight: "18px",
      fontFamily: "Poppins",
      fontStyle: "normal",
    },
    subtitle6: {
      fontFamily: "Poppins",
      fontSize: "16px",
      fontWeight: 300,
      lineHeight: "21px",
      letterSpacing: "0em",
      textAlign: "left",
    },
    subtitle7: {
      fontFamily: "Poppins",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "21px",
    },
    body1: {
      fontSize: 16,
      fontWeight: "300",
    },
    body2: {
      fontSize: 14,
      fontWeight: "300",
    },
    body3: {
      fontSize: 13,
      fontWeight: "600",
    },
    body4: {
      fontWeight: 600,
      fontSize: "16px",
    },
    body5: {
      fontFamily: "Poppins",
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "21px",
      letterSpacing: "0em",
      textAlign: "center",
    },
    accordion1: {
      fontFamily: "Bebas Neue",
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: "25px",
      lineHeight: "29px",
    },
    button: {
      fontWeight: 600,
      fontSize: 16,
    },
    allVariants: {
      fontFamily:
        '"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
    },
    head: {
      fontSize: 14,
      fontWeight: "600",
      color: "#B1B4BC",
    },
  },
});
